import { CircularProgress, Dialog, TextField } from '@material-ui/core';
import Button from 'shared/components/Button';
import { dark as darkColors, secondary } from 'shared/theme/colorTokens';
import { Query } from '@vadiun/react-hooks-legacy';
import { Field, Form, Formik, FormikProps } from 'formik';
import {
  Autocomplete,
  AutocompleteRenderInputParams
} from 'formik-material-ui-lab';
import React, { useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { ChoferPartialModel } from '../models/Chofer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie } from '@fortawesome/free-solid-svg-icons';
import { useThemeContext } from 'shared/context/themeContext';

interface Props {
  driversQuery: Query<ChoferPartialModel[]>;
  onSelect: (solicitante: ChoferPartialModel) => void;
  isOpen: boolean;
  handleClose: () => void;
}

type FormType = { driver: ChoferPartialModel | null };

const ChoferSearchModal = ({
  driversQuery,
  isOpen,
  handleClose,
  onSelect
}: Props) => {
  const { theme } = useThemeContext();
    const isDark = theme === 'dark';
  const formRef = useRef<FormikProps<FormType>>(null);

  useEffect(() => {
    if (isOpen) {
      formRef.current?.resetForm();
    }
  }, [isOpen]);


  
  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        handleClose();
        formRef.current?.resetForm();
      }}

        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            backgroundColor: isDark ? darkColors.surface : secondary[100],
            borderRadius: '15px',
          }
        }}
      >
        <div className="flex flex-col gap-4 p-6">
          <div className="flex gap-3 items-center mb-7">
            <FontAwesomeIcon icon={faUserTie} size="2x" className="text-secondary-500" />
            <p className='text-ink dark:text-ink-dark'>Seleccione un chofer</p>
          </div>
          <Formik<FormType>
            enableReinitialize
            initialValues={{
              driver: null
            }}
            onSubmit={async ({ driver }, formikHelpers) => {
              onSelect(driver!);
              formikHelpers.resetForm();
            }}
            validationSchema={Yup.object().shape({
              driver: Yup.mixed().required('Ingrese un Chofer').nullable()
            })}
            innerRef={formRef}
          >
            {({ touched, errors, submitForm }) => (
              <Form>
                <Field
                  name="driver"
                  component={Autocomplete}
                  className="col-span-2"
                  noOptionsText="No se han encontrado resultados"
                  loadingText="Cargando..."
                  fullWidth
                  options={driversQuery.data || []}
                  getOptionLabel={(option: ChoferPartialModel) =>
                    `${option.codigo} - ${option.nombreCompleto}`
                  }
                  renderInput={(params: AutocompleteRenderInputParams) => (
                    <TextField
                      {...params}
                      error={touched['driver'] && !!errors['driver']}
                      helperText={errors['driver']}
                      label="Chofer"
                      variant="outlined"
                      fullWidth
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {driversQuery.isLoading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        )
                      }}
                    />
                  )}
                />
                <div className="mt-8 flex justify-end">
                  <Button onClick={submitForm} variant="primary">
                    Continuar
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </Dialog>
      );
};

export default ChoferSearchModal;
